'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _commonFormsy = require('../common-formsy');

var _LeadSourceFormGroup = require('./LeadSourceFormGroup');

var _LeadSourceFormGroup2 = _interopRequireDefault(_LeadSourceFormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LeadSourceModal = (_dec = (0, _mobxReact.inject)('CaseStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(LeadSourceModal, _Component);

  function LeadSourceModal(props) {
    _classCallCheck(this, LeadSourceModal);

    var _this = _possibleConstructorReturn(this, (LeadSourceModal.__proto__ || Object.getPrototypeOf(LeadSourceModal)).call(this, props));

    _initDefineProp(_this, 'leadSource', _descriptor, _this);

    _initDefineProp(_this, 'isLoading', _descriptor2, _this);

    var leadSource = props._case.getLeadSource();
    _this.leadSource = leadSource ? leadSource.serialize() : {};
    return _this;
  }

  _createClass(LeadSourceModal, [{
    key: 'onValidSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(model, resetForm, invalidateForm) {
        var _props, _case, CaseStore, UiStore, caseId, _leadSource, category, name, id, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, _case = _props._case, CaseStore = _props.CaseStore, UiStore = _props.UiStore, caseId = _case.id, _leadSource = this.leadSource, category = _leadSource.category, name = _leadSource.name, id = _leadSource.id, data = { category: category, id: id, name: name };


                this.isLoading = true;
                _context.next = 4;
                return CaseStore.applyLeadSource(caseId, data);

              case 4:
                UiStore.modals.LeadSource.close();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onValidSubmit(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return onValidSubmit;
    }()
  }, {
    key: 'handleLeadSourceChange',
    value: function handleLeadSourceChange(leadSource) {
      this.leadSource = leadSource;
    }
  }, {
    key: 'render',
    value: function render() {
      var UiStore = this.props.UiStore,
          onClose = UiStore.modals.LeadSource.close,
          isValid = !!this.leadSource.category && !!this.leadSource.name;


      return _react2.default.createElement(
        _Modal2.default,
        { show: true, onHide: onClose },
        _react2.default.createElement(
          _commonFormsy.Form,
          { onValidChange: this.onValidChange, onValidSubmit: this.onValidSubmit },
          _react2.default.createElement(
            _Modal2.default.Header,
            { closeButton: true },
            _react2.default.createElement(
              _Modal2.default.Title,
              null,
              'Lead Source Info'
            )
          ),
          _react2.default.createElement(
            _Modal2.default.Body,
            null,
            _react2.default.createElement(_LeadSourceFormGroup2.default, {
              required: true,
              onChange: this.handleLeadSourceChange,
              leadSource: this.leadSource
            })
          ),
          _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'pull-right' },
              _react2.default.createElement(
                _Button2.default,
                { onClick: onClose },
                'Cancel'
              ),
              _react2.default.createElement(
                _Button2.default,
                { disabled: !isValid || this.isLoading, bsStyle: 'primary', type: 'submit' },
                this.isLoading ? 'Loading...' : 'Save'
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LeadSourceModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'leadSource', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = LeadSourceModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LeadSourceModal, 'LeadSourceModal', '/app/src/components/page-case/LeadSourceModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/LeadSourceModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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